<div [class.svg-shadow]="shadow"
     [class.overlay]="overlay"
     class="topbar-logo curpoint"
     (click)="clickAction()">
    <img alt="Van Velsen Reflectielijnen" src="assets/logos/VVR_b-rood.svg" *ngIf="!full && !dark">
    <img alt="Van Velsen Reflectielijnen" src="assets/logos/VVR_bw-rood.svg" *ngIf="full && !dark">
    <img alt="Van Velsen Reflectielijnen" src="assets/logos/VVR_b_wit-rood.svg" *ngIf="!full && dark">
    <img alt="Van Velsen Reflectielijnen" src="assets/logos/VVR_bw_wit-rood.svg" *ngIf="full && dark ">
</div>
